module.exports = __webpack_public_path__ + "img/cil-qr-code.2cdb88a4.svg";